import { render, staticRenderFns } from "./TrainingGeneralSettings.vue?vue&type=template&id=089e2c58&"
import script from "./TrainingGeneralSettings.vue?vue&type=script&lang=js&"
export * from "./TrainingGeneralSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports